import React, {useState, useEffect} from 'react';
import Input from '../../../../components/Input/Input';
import UserPicker from '../../../../containers/UserPicker/UserPicker';
import LeanIXPicker from '../../../../containers/LeanIXPicker/LeanIXPicker';
import EPPMPicker from '../../../../containers/ePPMPicker/ePPMPicker';
import formSectionWrapper from './FormSectionWrapper';
import * as rules from '../../../../config/Rules';
import { canEditWithRequestor, isDisabled } from '../../../../utils/changelogFormEditPrivileges';
import { isVendorTypeExternal, isActivityTypeBAU, isConsentTypeYes } from '../../../../utils/typesAssertions';
import RadioButtons from '../../../../components/RadioButtons/RadioButtons';
import { Grid, Button, Box } from '@material-ui/core';
import LeanIXMappingGrid from '../../../../containers/LeanIXMappingGrid/LeanIXMappingGrid';
import {addLeanIXMapping,  handlePercentageChange, handlePercentageKeyDown, handlePercentagePaste, } from '../../../../utils/leanixUtils'

const Roles = (props) => { 
    const [localScoutId, setLocalScoutId] = useState(props.scoutId || "");
    const leanIXMapping = props.leanIXMapping || [];
    const [selectedLeanix, setSelectedLeanix] = useState(null);
    const [percentage, setPercentage] = useState('');
    const [percentageError, setPercentageError] = useState('');
    const [leanIXError, setLeanIXError] = useState('');

    useEffect(() => {
        setLocalScoutId(props.scoutId || ""); // Sync when props.scoutId updates
    }, [props.scoutId]);

    useEffect(() => {
    setSelectedLeanix(null);
    setLeanIXError('');
    setPercentage('');
    setPercentageError('');
    }, [props.leanIXMapping]);

const totalPercentage = (
    leanIXMapping.reduce((sum, m) => sum + parseFloat(m.percentage || 0), 0)
);

const handleAddMapping = () => {
  const { updatedMappings, leanIXError, percentageError } = addLeanIXMapping({
    selectedLeanix,
    percentage,
    leanIXMapping,
    totalPercentage
  });

  if (leanIXError || percentageError) {
    setLeanIXError(leanIXError || "");
    setPercentageError(percentageError || "");
    return;
  }

    props.onLeanIXMappingChanged(updatedMappings);
  setSelectedLeanix(null);
  setPercentage("");
  setLeanIXError("");
  setPercentageError("");
};

const handleRemoveMapping = (index) => {
    const updated = leanIXMapping.filter((_, i) => i !== index);
    props.onLeanIXMappingChanged(updated);
};

    return (
        <React.Fragment>
            <Input label="Planner" width="100%" disabled value={props.planner || ''} className="disabled-form-input" />
            {canEditWithRequestor(props, rules.EDIT_CHANGELOG_DC_APPROVER) ?
                <UserPicker
                    error={props.errors.approver}
                    user={props.approver}
                    onChange={props.approverChanged}
                    label="Delivery Confirmation Approver"
                    className={props.changes.approver ? "input-updated" : ""}
                    tooltipText={props.changes.approver}
                /> :
                <Input
                    label="Delivery Confirmation Approver"
                    width="100%"
                    disabled
                    value={props.approver ? props.approver.label : ''}
                    className={props.changes.approver ? "input-updated" : "disabled-form-input"}
                    tooltipText={props.changes.approver}
                />
            }
            {/* {canEditWithRequestor(props, rules.EDIT_CHANGELOG_LEANIX) ?
                <LeanIXPicker
                    error={props.errors.leanix}
                    leanix={props.leanixdto}
                    onChange={props.leanixChanged}
                    label="LeanIX ID"
                    className={props.changes.leanixdto ? "input-updated" : ""}
                    tooltipText={props.changes.leanixdto}
                /> :
                <Input
                    label="LeanIX ID"
                    width="100%"
                    disabled
                    value={props.leanixdto ? props.leanixdto.label : ''}
                    className={props.changes.leanixdto ? "input-updated" : "disabled-form-input"}
                    tooltipText={props.changes.leanixdto}
                /> */}

                {canEditWithRequestor(props, rules.EDIT_CHANGELOG_LEANIX) ? (
                    <>
                        <Box mt={2}>
                        <Grid container spacing={1} alignItems="flex-start">
                            {/* LeanIX Picker */}
                            <Grid item xs={7} style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 4 }}>
                            <Box display="flex" flexDirection="column" minHeight="60px" mt={1} mb={0.5}>
                                <LeanIXPicker
                                leanix={selectedLeanix}
                                onChange={(value) => {
                                    setSelectedLeanix(value);
                                    if (leanIXError) {
                                    setLeanIXError(""); // clear the error when user selects a new LeanIX
                                    }
                                }}
                                label="LeanIX ID"
                                width="100%"
                                error={!!leanIXError}
                                errorText={leanIXError}
                                />
                            </Box>
                            </Grid>

                            {selectedLeanix && (
                            <>
                                {/* Percentage Input */}
                                <Grid item xs={3} style={{ paddingLeft: 2, paddingRight: 5, paddingBottom: 4 }}>
                                <Box display="flex" flexDirection="column" minHeight="60px" mt={1} mb={0.5}>
                                        <Input
                                        label="Percentage"
                                        type="text"
                                        errorText={percentageError}
                                        value={percentage}
                                        onChange={(e) =>
                                            handlePercentageChange(e.target.value, setPercentage, setPercentageError)
                                        }
                                        onKeyDown={handlePercentageKeyDown}
                                        onPaste={handlePercentagePaste}
                                        width="100%"
                                        className={percentageError ? "input-error" : ""}
                                        />
                                </Box>
                                </Grid>

                                {/* Add Button */}
                                <Grid item xs={2} style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 4, paddingTop: 17  }}>
                                <Box mt={1} display="flex" alignItems="flex-start" minHeight="60px">
                                    <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleAddMapping}
                                    fullWidth
                                    >
                                    Add
                                    </Button>
                                </Box>
                                </Grid>
                            </>
                            )}
                        </Grid>
                        </Box>

                        {/* Mapping Grid */}
                        {(leanIXMapping.length > 0 || props.changes?.leanIXMappingsTable === 'table-deleted') && (
                        <LeanIXMappingGrid
                            mappings={leanIXMapping}
                            onLeanIXMappingChanged={(updated) => {
                                props.onLeanIXMappingChanged(updated);
                                }}
                            onRemove={handleRemoveMapping}
                            errorText=""
                            isReadOnly={false}
                            remainingPercentage={(100 - totalPercentage).toFixed(1)}
                            fieldErrors={props.errors?.leanIXMapping || []}
                            summaryError={props.errors?.leanIXMappingSummary}
                            errors = {props.errors?.leanIXMapping || []}
                            changes={props.changes?.leanIXMappings}
                            tableChange={props.changes?.leanIXMappingsTable}
                        />
                        )}
                    </>
                    ) : (
                        props.leanIXMapping?.length > 0 ||
                        props?.changes.leanIXMappings?.length > 0 ||
                        props?.changes.leanIXMappingsTable === 'table-deleted'
                        ) && (
                        <LeanIXMappingGrid
                        mappings={props.leanIXMapping}
                        isReadOnly={true}
                        label="LeanIX Allocation"
                        changes={props.changes?.leanIXMappings}
                        tableChange={props.changes?.leanIXMappingsTable}
                        />
                    )
                    }

            {!isActivityTypeBAU(props.activityType.value) ? null :
                <>
                    <RadioButtons
                        header="New IT BAU"
                        horizontal={true}
                        onChange={props.onconsentTypeChanged}
                        options={props.consentTypes}
                        value={props.consentType}
                        disabled={isDisabled(props, rules.EDIT_CHANGELOG_EPPM)}
                        className={props.changes.consentType ? "input-updated" : ""}
                        tooltipText={props.changes.consentType}
                    />
                    {(isConsentTypeYes(props.consentType.value) || props.changes.consentType === "YES") ? (
                        <>
                            {canEditWithRequestor(props, rules.EDIT_CHANGELOG_EPPM) ?
                                <EPPMPicker
                                    error={props.errors.eppm}
                                    eppm={props.ePPMDto}
                                    onChange={props.eppmChanged}
                                    label="EPPM Project ID"
                                    className={props.changes.ePPMDto ? "input-updated" : ""}
                                    tooltipText={props.changes?.ePPMDto?.label}
                                /> :
                                <Input
                                    label="EPPM Project ID"
                                    width="100%"
                                    disabled
                                    value={props.ePPMDto ? props.ePPMDto.label : ''}
                                    className={props.changes.ePPMDto ? "input-updated" : "disabled-form-input"}
                                    tooltipText={props.changes?.ePPMDto?.label}
                                />
                            }
                            <Input
                                label="EPPM Project Name"
                                width="100%"
                                disabled
                                value={props.ePPMDto ? props.ePPMDto.value : ''}
                                className={props.changes.ePPMDto ? "input-updated" : "disabled-form-input"}
                                tooltipText={props.changes?.ePPMDto?.value}
                            />
                        </>
                    ) : null}
                </>

            }


            {(!props.vendorType || !props.vendorType.label || !isVendorTypeExternal(props.vendorType.value)) ? null :
                <React.Fragment>
                    {canEditWithRequestor(props, rules.EDIT_CHANGELOG_SUPPLIER_REPRESENTATIVE) ?
                        <UserPicker
                            error={props.errors.supplierRepresentative}
                            user={props.supplierRepresentative}
                            onChange={props.supplierChanged}
                            label="Supplier Representative"
                            className={props.changes.supplierRepresentative ? "input-updated" : ""}
                            tooltipText={props.changes.supplierRepresentative || ""}
                        /> :
                        <Input
                            label="Supplier Representative"
                            width="100%"
                            disabled
                            value={props.supplierRepresentative ? props.supplierRepresentative.label : ''}
                            className={props.changes.supplierRepresentative ? "input-updated" : "disabled-form-input"}
                            tooltipText={props.changes.supplierRepresentative || ""}
                        />
                    }
                </React.Fragment>
            }
                        {canEditWithRequestor(props, rules.EDIT_CHANGELOG_SCOUT_ID) ? (
                        <div>
                            <Input 
                                label="Scout ID"
                                value={localScoutId}  
                                onChange={(e) => setLocalScoutId(e.target.value)} // Update local state immediately
                                onBlur={() => {
                                    if (localScoutId !== props.scoutId) { // Only dispatch if value changed
                                        // console.log("Scout ID updated on blur:", localScoutId);
                                        props.onScoutIdChanged(localScoutId);
                                    }
                                }}
                                className={props.changes.scoutId ? "input-updated" : ""}
                                tooltipText={props.changes.scoutId}
                            />
                            <span style={{ fontSize: "9px", color: "grey", display: "block", marginTop: "4px" }}>
                                Kindly include the Scout ID only if the total value exceeds: 250,000 USD/ 250,000 GBP/ 250,000 EUR/ 250,000 CHF 
                                or 250,000 USD if Changelog is in any other currency. Otherwise, please omit the Scout ID to avoid complications in the 
                                purchase order creation process.
                            </span>
                        </div>
                    ) : (
                        props.scoutId && (
                        <div>
                            <Input 
                                label="Scout ID"
                                value={props.scoutId || ""}  
                                disabled
                                className={props.changes.scoutId ? "input-updated" : "disabled-form-input"}
                                tooltipText={props.changes.scoutId}
                            />
                            {/* <span style={{ fontSize: "9px", color: "grey", display: "block", marginTop: "4px" }}>
                                Kindly include the Scout ID only if the total value exceeds: 250,000 USD/ 250,000 GBP/ 250,000 EUR/ 250,000 CHF 
                                or 250,000 USD if Changelog is in any other currency. Otherwise, please omit the Scout ID to avoid complications in the 
                                purchase order creation process.
                            </span> */}
                        </div>
                    ))}
        </React.Fragment>
    )
}
export default formSectionWrapper(Roles, "Roles"); 